export default "__VITE_ASSET__d0980ddc__"